<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside class="layout-aside" width="220px">
      <div class="logo">
        <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" alt="logo">
        <span>SINCEGAME SSO</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
        class="layout-menu"
      >
        <el-menu-item v-for="item in menuRoutes" :key="item.path" :index="item.path">
          <i :class="item.meta.icon" />
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部导航 -->
      <el-header class="layout-header" height="60px">
        <div class="header-left">
          <i class="el-icon-s-fold collapse-btn" />
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.title">
              {{ currentRoute.meta.title }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-tooltip content="语言" placement="bottom">
            <div class="lang-switch">
              <span class="lang-active">EN</span>
            </div>
          </el-tooltip>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="user-info">
              <el-avatar size="small" icon="el-icon-user-solid" />
              <span class="username">{{ username }}</span>
              <el-tag v-if="roleName" :type="isAdmin ? 'danger' : 'info'" size="mini">
                {{ roleName }}
              </el-tag>
              <i class="el-icon-arrow-down el-icon--right" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item command="settings">系统设置</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主内容区 -->
      <el-main class="layout-main">
        <router-view :key="$route.fullPath" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '../api/auth';
import { canSee, isAdmin } from '../router';

export default {
  name: 'Layout',
  computed: {
    // 兼容两种存法：纯文本（用户名）或 JSON（{ username, role }）
    username() {
      const raw = localStorage.getItem('sso_user') || '';
      if (!raw) return '未登录';
      try {
        const u = JSON.parse(raw);
        if (u && typeof u === 'object') return u.username || u.name || raw;
      } catch (e) {
        // 不是 JSON，按纯文本处理
      }
      return raw;
    },
    roleName() {
      return localStorage.getItem('sso_role') || '';
    },
    isAdmin() {
      return isAdmin();
    },
    activeMenu() {
      return this.$route.path;
    },
    currentRoute() {
      return this.$route;
    },
    // 从路由配置自动生成菜单，无需手动维护
    menuRoutes() {
      const layoutRoute = this.$router.options.routes.find(r => r.path === '/');
      if (!layoutRoute || !layoutRoute.children) return [];
      return layoutRoute.children
        // 只显示有标题、且当前用户有权访问的菜单（adminOnly 的仅管理员可见）
        .filter(r => r.meta && r.meta.title && canSee(r.meta))
        .map(r => ({
          path: '/' + r.path,
          meta: r.meta
        }));
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      } else if (command === 'profile') {
        this.$message.info('个人中心');
      } else if (command === 'settings') {
        this.$message.info('系统设置');
      }
    },
    async logout() {
      // 先通知后端使当前 token 失效
      try {
        await logout();
      } catch (e) {
        // 忽略错误，继续清除本地
      }
      localStorage.removeItem('sso_token');
      localStorage.removeItem('sso_user');
      localStorage.removeItem('sso_role');
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.layout-aside {
  background-color: #304156;
  transition: width 0.3s;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  background-color: #263445;
  border-bottom: 1px solid #1f2d3d;
}
.logo img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-right: 10px;
}
.layout-menu {
  border-right: none;
}
.layout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.header-left {
  display: flex;
  align-items: center;
}
.collapse-btn {
  font-size: 20px;
  color: #606266;
  cursor: pointer;
  margin-right: 15px;
}
.breadcrumb {
  line-height: 60px;
}
.header-right {
  display: flex;
  align-items: center;
}
.lang-switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 24px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-right: 20px;
  cursor: pointer;
  color: #606266;
  font-size: 12px;
}
.lang-active {
  font-weight: bold;
  color: #409EFF;
}
.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-info .username {
  margin: 0 8px;
  color: #606266;
  font-size: 14px;
}
.layout-main {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
</style>